import styled from "styled-components";

const DetailList = styled.ul`
  list-style: none;
`;

export default DetailList;
